module.exports = __webpack_public_path__ + "static/media/img_system5.a1246bad.png";